import { Flex, MultiSelect, Select } from '@mantine/core';
import { CustomFilter } from '../api/common';

export type ApiKeyFilters = {
  organisation?: CustomFilter;
  scope?: CustomFilter;
  $showDeleted?: string;
};

export const ApiKeyFilter = ({
  organisations,
  knownApps,
  onChange,
}: {
  organisations: string[];
  knownApps: string[];
  onChange: (k: string, v: string | string[]) => void;
}) => {
  return (
    <Flex align="center" mb="lg" gap="md" wrap="wrap">
      <MultiSelect
        data={organisations}
        label="Organisation"
        miw={250}
        onChange={(value) => onChange('organisation', value ?? '')}
      />
      <MultiSelect
        data={knownApps}
        label="Application"
        miw={250}
        onChange={(value) => onChange('scope', value ?? '')}
      />
      <Select
        data={[
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' },
        ]}
        label="Show Deleted"
        onChange={(value) => onChange('$showDeleted', value ?? '')}
      />
    </Flex>
  );
};
